import { Request } from '../../../httpClient/serverApi/requests/Request';
import { DatasourceIdToConnectionIdsMap } from '../types/DatasourceIdToConnectionIdsMap';

export class GetDataConnectionIdsFromDatasourcesRequest extends
    Request<{ datasourceIds: string[] }, DatasourceIdToConnectionIdsMap> {
  constructor(datasourceIds: string[]) {
    super('getDataConnectionIdsFromDatasources', { datasourceIds });
  }
}
